import styled from 'styled-components';

export const Container = styled.div`
  .col-md-6 {
    padding: 0;
  }
`;
